import { render } from "./LoginAlert.vue?vue&type=template&id=1ddc6dfd"
import script from "./LoginAlert.vue?vue&type=script&lang=js"
export * from "./LoginAlert.vue?vue&type=script&lang=js"

import "./LoginAlert.vue?vue&type=style&index=0&id=1ddc6dfd&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__